// delta-03 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "#%{arg1}": "#%{arg1}",
    "%{arg1} · %{arg2}": "%{arg1} · %{arg2}",
    "%{arg1}%{arg2}": "%{arg1}%{arg2}",
    "%{arg1}d": "%{arg1}d",
    "+%{arg1}": "+%{arg1}",
    "+%{arg1} gap": "+%{arg1} brecha",
    ", com regra por compra na loja, limite por cliente, etiqueta e agendamento.": ", con regla por compra en la tienda, límite por cliente, etiqueta y programación.",
    "0.85rem": "0.85rem",
    "1fr": "1fr",
    "1fr 1fr": "1fr 1fr",
    "1px": "1px",
    "1px solid rgba(148,163,184,0.2)": "1px solid rgba(148,163,184,0.2)",
    "1px solid rgba(239,68,68,0.28)": "1px solid rgba(239,68,68,0.28)",
    "1px solid rgba(245,158,11,0.30)": "1px solid rgba(245,158,11,0.30)",
    "30d": "30d",
    "7d": "7d",
    "90d": "90d",
    "A data final deve ser maior que a data de inicio": "La fecha final debe ser mayor que la fecha de inicio",
    "A data final deve ser uma data válida": "La fecha final debe ser una fecha válida",
    "A data inicial deve ser uma data válida": "La fecha inicial debe ser una fecha válida",
    "A descrição deve ter no máximo 500 caracteres": "La descripción debe tener como máximo 500 caracteres",
    "A nota do cliente e o que a IA lê nos comentários estão alinhados — sinal consistente.": "La calificación del cliente y lo que la IA lee en los comentarios están alineados — señal consistente.",
    "Adicione pelo menos um produto ao brinde": "Agregue al menos un producto al premio",
    "Aguarde mais avaliações com comentário para comparar nota e leitura da IA.": "Espere más evaluaciones con comentario para comparar la calificación y la lectura de la IA.",
    "Alinhado": "Alineado",
    "As regras deste sorteio ficam aqui mesmo, e continuam funcionando — nada precisa ser refeito. Sorteios criados de agora em diante têm as regras no": "Las reglas de este sorteo quedan aquí mismo, y siguen funcionando — no hace falta rehacer nada. Los sorteos creados de ahora en adelante tienen las reglas en el",
    "Ative pelo menos um dia da semana": "Active al menos un día de la semana",
    "Campeões": "Campeones",
    "Campo de descrição está vazio": "El campo de descripción está vacío",
    "Clientes duros": "Clientes duros",
    "Clientes estão dando nota boa (%{arg1} ponto%{arg2} acima) mas o que escrevem mostra mais problemas. Vale investigar.": "Los clientes están dando buena calificación (%{arg1} punto%{arg2} arriba) pero lo que escriben muestra más problemas. Vale la pena investigar.",
    "Custo em pontos": "Costo en puntos",
    "Defina horário de início e fim para todos os dias ativos": "Defina horario de inicio y fin para todos los días activos",
    "Defina um horário de envio válido": "Defina un horario de envío válido",
    "Defina um horário de início e fim para a frequência diária": "Defina un horario de inicio y fin para la frecuencia diaria",
    "Defina um limite de uso ou remova o intervalo de uso": "Defina un límite de uso o quite el intervalo de uso",
    "Defina um método de notificação": "Defina un método de notificación",
    "Defina um tempo de envio para a notificação de conquista": "Defina un tiempo de envío para la notificación de logro",
    "Defina um título para a notificação de conquista": "Defina un título para la notificación de logro",
    "Defina um título para a notificação de criação": "Defina un título para la notificación de creación",
    "Defina um título para notificação": "Defina un título para la notificación",
    "Defina uma data de início": "Defina una fecha de inicio",
    "Defina uma data de início válida": "Defina una fecha de inicio válida",
    "Defina uma data e hora de envio para a notificação de criação": "Defina una fecha y hora de envío para la notificación de creación",
    "Defina uma data final válida": "Defina una fecha final válida",
    "Defina uma descrição para a notificação de conquista": "Defina una descripción para la notificación de logro",
    "Defina uma descrição para a notificação de criação": "Defina una descripción para la notificación de creación",
    "Defina uma descrição para notificação": "Defina una descripción para la notificación",
    "Defina uma mensagem push para a notificação de conquista": "Defina un mensaje push para la notificación de logro",
    "Defina uma mensagem push para a notificação de criação": "Defina un mensaje push para la notificación de creación",
    "Defina uma messagem push": "Defina un mensaje push",
    "Defina uma messagem sms": "Defina un mensaje SMS",
    "Defina uma tag ou grupo de clientes": "Defina una etiqueta o grupo de clientes",
    "Desconto de valor em compra": "Descuento de valor en compra",
    "Desconto geral vinculado a postos. Disponível para qualquer cliente que abastecer nos postos selecionados.": "Descuento general vinculado a estaciones. Disponible para cualquier cliente que cargue combustible en las estaciones seleccionadas.",
    "Desconto vinculado a postos e segmentado por grupos, tags ou cidades. Suporta agendamento por período e envio de notificações.": "Descuento vinculado a estaciones y segmentado por grupos, etiquetas o ciudades. Admite programación por período y envío de notificaciones.",
    "Desconto vinculado ao Clube de Vantagens. Concedido ao cliente como prêmio ao resgatar um presente.": "Descuento vinculado al Club de Beneficios. Otorgado al cliente como premio al canjear un regalo.",
    "Desconto vinculado à regra de recuperação de clientes inativos. Cada cliente recebe seu próprio desconto conforme o nível em que se encontra.": "Descuento vinculado a la regla de recuperación de clientes inactivos. Cada cliente recibe su propio descuento según el nivel en que se encuentra.",
    "Detalhe da rede": "Detalle de la red",
    "Diferença de %{arg1} ponto entre nota e sentimento. Mantenha de olho.": "Diferencia de %{arg1} punto entre calificación y sentimiento. Manténgase atento.",
    "Diária": "Diaria",
    "Em progresso": "En progreso",
    "Email verificado com sucesso!": "¡Email verificado con éxito!",
    "Entre em contato com o suporte.": "Póngase en contacto con soporte.",
    "Este sorteio não tem regras próprias. Quem decide quem ganha número da sorte, quando e quantos é o Clube de Vantagens: a recompensa": "Este sorteo no tiene reglas propias. Quien decide quién gana Número de la Suerte, cuándo y cuántos es el Club de Beneficios: el premio",
    "Finalizado": "Finalizado",
    "Fiéis": "Fieles",
    "Formas de pagamento por parceiros": "Formas de pago por socios comerciales",
    "Gerando...": "Generando...",
    "Hibernando": "Hibernando",
    "Leve divergência": "Leve divergencia",
    "Link inválido ou expirado": "Enlace inválido o expirado",
    "Negativo": "Negativo",
    "Nenhum desconto foi definido": "Ningún descuento fue definido",
    "Nenhum destaque no período": "Ningún destacado en el período",
    "Nenhum disparo no período.": "Ningún envío en el período.",
    "Nenhum elogio selecionado": "Ningún elogio seleccionado",
    "Nenhum frentista em alerta": "Ningún playero en alerta",
    "Nenhum sinal de risco acionado": "Ninguna señal de riesgo activada",
    "Nenhuma crítica selecionada": "Ninguna crítica seleccionada",
    "Nenhuma rede encontrada com os filtros atuais.": "Ninguna red encontrada con los filtros actuales.",
    "Neutro": "Neutro",
    "Nome do Nível %{arg1}": "Nombre del Nivel %{arg1}",
    "Nota do cliente levemente acima da leitura da IA (%{arg1}). Provavelmente educação nas estrelas — monitore.": "Calificación del cliente levemente por encima de la lectura de la IA (%{arg1}). Probablemente cortesía en las estrellas — monitoree.",
    "Não iniciado": "No iniciado",
    "Não se repete": "No se repite",
    "Nível %{arg1}": "Nivel %{arg1}",
    "O link de verificação não é mais válido. Isso ocorre quando o link já foi utilizado anteriormente ou quando ele expirou após 24 horas da criação da conta.": "El enlace de verificación ya no es válido. Esto ocurre cuando el enlace ya fue utilizado anteriormente o cuando expiró después de 24 horas de la creación de la cuenta.",
    "O que os clientes escrevem é mais leve do que a nota (%{arg1} ponto%{arg2} abaixo). Podem estar sendo severos nas estrelas por um detalhe específico.": "Lo que los clientes escriben es más leve que la calificación (%{arg1} punto%{arg2} abajo). Pueden estar siendo severos en las estrellas por un detalle específico.",
    "O valor máximo de Dotz para o desconto %{arg1} de %{arg2} é %{arg3}": "El valor máximo de Dotz para el descuento %{arg1} de %{arg2} es %{arg3}",
    "Opcional para este tipo de desconto": "Opcional para este tipo de descuento",
    "Personalizado": "Personalizado",
    "Positivo": "Positivo",
    "Preparando a carteira pela primeira vez… os dados aparecem assim que o cálculo terminar.": "Preparando la cartera por primera vez… los datos aparecen en cuanto el cálculo termine.",
    "Promissores": "Prometedores",
    "Recuperação": "Recuperación",
    "Resumir": "Resumir",
    "Retentando...": "Reintentando...",
    "Retentar": "Reintentar",
    "Risco silencioso": "Riesgo silencioso",
    "Sem dados suficientes": "Sin datos suficientes",
    "Sorteado": "Sorteado",
    "Sua conta foi ativada e está pronta para uso. Acesse o sistema com o login e senha que foram cadastrados pelo administrador.": "Su cuenta fue activada y está lista para usar. Acceda al sistema con el usuario y la contraseña registrados por el administrador.",
    "ainda não rodou": "aún no se ejecutó",
    "alinhado": "alineado",
    "clientes duros": "clientes duros",
    "clube": "club",
    "column": "column",
    "contained": "contained",
    "custom": "custom",
    "data inválida": "fecha inválida",
    "date": "date",
    "description": "description",
    "div": "div",
    "do brinde é que aponta para este sorteio.": "del premio es el que apunta a este sorteo.",
    "grid": "grid",
    "info": "info",
    "is": "is",
    "linear-gradient(135deg, #22c55e, #16a34a)": "linear-gradient(135deg, #22c55e, #16a34a)",
    "linear-gradient(135deg, #ef4444, #dc2626)": "linear-gradient(135deg, #ef4444, #dc2626)",
    "loja": "tienda",
    "módulos pagos e parados": "módulos pagados y detenidos",
    "nenhum módulo parado": "ningún módulo detenido",
    "nenhuma rede no recorte atual": "ninguna red en el recorte actual",
    "notification.title": "notification.title",
    "places": "places",
    "praise": "praise",
    "recovery": "recovery",
    "repeat(4, 1fr)": "repeat(4, 1fr)",
    "reward": "reward",
    "rgba(239,68,68,0.08)": "rgba(239,68,68,0.08)",
    "rgba(245,158,11,0.10)": "rgba(245,158,11,0.10)",
    "risco silencioso": "riesgo silencioso",
    "rotate(360deg)": "rotate(360deg)",
    "sem fatura no período": "sin factura en el período",
    "special": "special",
    "station": "station",
    "uppercase": "uppercase",
    "wrap": "wrap",
    "Última análise: %{arg1}": "Último análisis: %{arg1}",
};

export default catalogo;
